import { Form, FormInstance, Input, Typography } from "antd";
import { GetOrderDetailData } from "services/interface";
import { useEffect } from "react";

interface PostalLabelProps {
  formPostal: FormInstance<any>;
  item: GetOrderDetailData;
  refetchData: () => void;
  refectShipped?: () => void;
  onClose: () => void;
}

const PostalLabel = ({ formPostal, item, refetchData, refectShipped, onClose }: PostalLabelProps) => {

  useEffect(() => {
    if (item.history_postal.brand_id) {
      formPostal.setFieldsValue({
        selectOrganize: item?.history_postal.brand_name,
        postalCode: item?.history_postal.postal_code,
        description: item?.history_postal.transport_detail,
        remark: item?.history_postal.postal_remark,
      });
    }
  }, [formPostal, item]);

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <Typography.Text style={{ fontSize: 14, fontWeight: 400 }}>
          กำหนดการจัดส่ง
        </Typography.Text>
      </div>
      <Form form={formPostal}>
        <Form.Item
          label="ประเภทขนส่ง"
          name="selectOrganize"
        >
          <Input size="small" placeholder="ประเภทขนส่ง"  readOnly={true}/>
        </Form.Item>
        <Form.Item
          label="เลข Tracking"
          name="postalCode"
        >
          <Input size="small" placeholder="เลข Tracking"  readOnly={true}/>
        </Form.Item>
        {/* <Form.Item label="รายละเอียด" name="description">
          <Input.TextArea placeholder="รายละเอียด"  readOnly={true}/>
        </Form.Item> */}
        <Form.Item label="หมายเหตุจัดส่ง" name="remark">
          <Input.TextArea placeholder="หมายเหตุจัดส่ง" readOnly={true} />
        </Form.Item>
      </Form>
    </div>
  );
};

export default PostalLabel;
